import { useNavigate } from 'react-router';
import { Camera } from 'lucide-react';

import { useDispatch } from 'react-redux';
import { showSearch } from '../../../../redux/features/dashboard/dashboardSlice';

import { ItemFooter } from '../ItemFooter';
import { ItemHeader } from '../ItemHeader';
import { OwnersRealty } from '../../realtyCard/OwnersRealty';

import { generateStringValue } from '../../../../utils/utils';
import { colors } from '../../../../data/constants';

export const ListingsItem = ({ reminder = {}, group, setIsLoading = () => {} }) => {
  const { realty = {}, contacts, agent, subject, created } = reminder;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const newAdress = generateStringValue([
    realty?.street_number,
    realty?.street,
    realty?.postal_code,
    realty?.city,
  ]);

  const handleRealtyIdClick = () => {
    navigate('/');

    dispatch(
      showSearch({
        isSearchVisible: true,
        searchQuery: realty?.id,
        searchFilters: '',
      })
    );
  };

  return (
    <div className="flex flex-col gap-2 p-2 w-full h-full min-w-0 bg-gray-100 rounded">
      <ItemHeader reminder={reminder} group={group} />

      {realty && (
        <>
          <div className="flex gap-2 w-full">
            <div className="relative flex shrink-0 justify-center items-center w-1/5 min-w-[80px] aspect-[4/3] bg-whiteColor rounded">
              {realty?.preview ? (
                <img
                  className="absolute w-full h-full object-center object-cover rounded"
                  src={realty?.preview}
                  alt="realty"
                />
              ) : (
                <Camera
                  size={26}
                  color={colors.darkGrayColor}
                />
              )}
            </div>

            <div className="flex flex-col gap-0.5 min-w-0">
              <span
                className="block text-sm text-blackColor cursor-pointer hover:underline"
                onClick={handleRealtyIdClick}
              >
                {newAdress}
              </span>

              {realty?.price && (
                <span className="block text-xs text-blackColor">
                  {realty.price} €
                </span>
              )}

              <span className="text-xs text-gray-500">
                Realty ID:{' '}
                <span
                  className="text-darkBlueColor underline cursor-pointer"
                  onClick={handleRealtyIdClick}
                >
                  {realty?.id}
                </span>
              </span>
            </div>
          </div>

          {contacts && contacts?.length > 0 && (
            <OwnersRealty
              contacts={contacts}
            />
          )}
        </>
      )}

      <ItemFooter
        agent={agent.name}
        subject={subject}
        created={created}
      />
    </div>
  );
};
